export default "__VITE_ASSET__d102d943__"